module.exports = __webpack_public_path__ + "img/Danger.bad7a89b.png";